import { RouteConfig } from "vue-router";
import Layout from "@/layout/index.vue";

const customsManagementRoutes: RouteConfig[] = [
  {
    path: "/customs-management",
    component: Layout,
    redirect: "/customs-management",
    name: "CustomsDeclarationManagement",
    meta: {
      title: "customsManagement",
      icon: "el-icon-location",
      alwaysShow: true,
    },
    children: [
      {
        path: "/shipping-management",
        component: () =>
          import("@/views/customs-management/ShippingOrderManagement.vue"),
        name: "ShippingOrderManagement",
        meta: { title: "shippingManagement" },
      },
      {
        path: "booking-orders",
        component: () =>
          import(
            "@/views/customs-management/LogisticsBookingOrderManagement.vue"
          ),
        name: "LogisticsBookingOrderManagement",
        meta: { title: "logisticsBookingOrderManagement" },
      },
    ],
  },
];

export default customsManagementRoutes;
